'use client';

import { useTranslations } from 'next-intl';
import { FeatureDetailContent } from './FeatureDetailContent';
import {
    Wallet,
    CreditCard,
    Banknote,
    Globe,
    Shield,
    History
} from 'lucide-react';

export function EWalletContent() {
    const t = useTranslations('eWallet');

    const features = [
        {
            icon: Wallet,
            title: t('features.step1.title'),
            description: t('features.step1.description'),
        },
        {
            icon: CreditCard,
            title: t('features.step2.title'),
            description: t('features.step2.description'),
        },
        {
            icon: Banknote,
            title: t('features.step3.title'),
            description: t('features.step3.description'),
        },
        {
            icon: Globe,
            title: t('features.step4.title'),
            description: t('features.step4.description'),
        },
        {
            icon: Shield,
            title: t('features.step5.title'),
            description: t('features.step5.description'),
        },
        {
            icon: History,
            title: t('features.step6.title'),
            description: t('features.step6.description'),
        },
    ];

    const benefits = t.raw('benefits.list') as string[];

    return (
        <FeatureDetailContent
            pageKey="e-wallet"
            translationNamespace="eWallet"
            features={features}
            benefits={benefits}
            ctaIcon={Wallet}
            showWhatIsBitcoin={true}
            introImageSrc="/images/features/E-wallet.webp"
            introImageAlt={t('intro.imageAlt') || 'E-Wallet Integration in MLM Software'}
            introParagraphKeys={['paragraph1', 'paragraph2']}
            introSectionHeadingPage="e-wallet"
            introSectionHeadingTitle={t('intro.sectionHeadingTitle') || 'About E-Wallet Integration'}
            introSectionHeadingPill={t('intro.sectionHeadingPill') || 'E-Wallet Integration'}
            useLocaleContent={true}
        />
    );
}

